export class ChartIAE extends Error {
    constructor(message: string) {
        super();
        this.message = message;
        this.name = 'ChartIAE';
    }
}
